import { cn } from "@fronterahealth/frontera-ui-components/lib/utils";
import { Textarea } from "@fronterahealth/frontera-ui-components/ui/textarea";

import { ReportFieldDisabledValue } from "@components/ReportField/ReportFieldDisabledValue";
import { ReportFieldInputBaseProps } from "@components/ReportField/types";

export const ReportFieldInput: React.FC<ReportFieldInputBaseProps> = ({
  id,
  value,
  onChange,
  variant,
  placeholder,
  disabled,
  onFocus,
  onBlur,
  ariaInvalid,
  className,
}) => {
  if (disabled) {
    return <ReportFieldDisabledValue value={value} />;
  }
  return (
    <Textarea
      className={cn("min-h-auto!", className)}
      id={id}
      variant={variant}
      value={value ?? ""}
      placeholder={placeholder}
      onChange={(e) => onChange(e.target.value.replace(/\r?\n/g, ""))}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          e.currentTarget.blur();
        }
      }}
      onFocus={onFocus}
      onBlur={onBlur}
      aria-invalid={ariaInvalid}
    />
  );
};
